module.exports = __webpack_public_path__ + "img/webinarinc-icon-black.a26443c2.png";